[
  {
    "code": "KG",
    "label": {
      "en": "Kilogram",
      "es": "Kilogramo"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "symbol": "kg",
      "category": "weight"
    }
  },
  {
    "code": "G",
    "label": {
      "en": "Gram",
      "es": "Gramo"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "symbol": "g",
      "category": "weight"
    }
  },
  {
    "code": "MG",
    "label": {
      "en": "Milligram",
      "es": "Miligramo"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "symbol": "mg",
      "category": "weight"
    }
  },
  {
    "code": "T",
    "label": {
      "en": "Ton",
      "es": "Tonelada"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "symbol": "t",
      "category": "weight"
    }
  },
  {
    "code": "L",
    "label": {
      "en": "Liter",
      "es": "Litro"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "symbol": "l",
      "category": "volume"
    }
  },
  {
    "code": "ML",
    "label": {
      "en": "Milliliter",
      "es": "Mililitro"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "symbol": "ml",
      "category": "volume"
    }
  },
  {
    "code": "M3",
    "label": {
      "en": "Cubic Meter",
      "es": "Metro cubico"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "symbol": "m3",
      "category": "volume"
    }
  },
  {
    "code": "M",
    "label": {
      "en": "Meter",
      "es": "Metro"
    },
    "order": 20,
    "is_active": true,
    "metadata": {
      "symbol": "m",
      "category": "length"
    }
  },
  {
    "code": "CM",
    "label": {
      "en": "Centimeter",
      "es": "Centimetro"
    },
    "order": 21,
    "is_active": true,
    "metadata": {
      "symbol": "cm",
      "category": "length"
    }
  },
  {
    "code": "MM",
    "label": {
      "en": "Millimeter",
      "es": "Milimetro"
    },
    "order": 22,
    "is_active": true,
    "metadata": {
      "symbol": "mm",
      "category": "length"
    }
  },
  {
    "code": "KM",
    "label": {
      "en": "Kilometer",
      "es": "Kilometro"
    },
    "order": 23,
    "is_active": true,
    "metadata": {
      "symbol": "km",
      "category": "length"
    }
  },
  {
    "code": "M2",
    "label": {
      "en": "Square Meter",
      "es": "Metro cuadrado"
    },
    "order": 30,
    "is_active": true,
    "metadata": {
      "symbol": "m2",
      "category": "area"
    }
  },
  {
    "code": "HA",
    "label": {
      "en": "Hectare",
      "es": "Hectarea"
    },
    "order": 31,
    "is_active": true,
    "metadata": {
      "symbol": "ha",
      "category": "area"
    }
  },
  {
    "code": "UNIT",
    "label": {
      "en": "Unit",
      "es": "Unidad"
    },
    "order": 40,
    "is_active": true,
    "metadata": {
      "symbol": "ud",
      "category": "count"
    }
  },
  {
    "code": "DOZEN",
    "label": {
      "en": "Dozen",
      "es": "Docena"
    },
    "order": 41,
    "is_active": true,
    "metadata": {
      "symbol": "dz",
      "category": "count"
    }
  },
  {
    "code": "PAIR",
    "label": {
      "en": "Pair",
      "es": "Par"
    },
    "order": 42,
    "is_active": true,
    "metadata": {
      "symbol": "par",
      "category": "count"
    }
  },
  {
    "code": "BOX",
    "label": {
      "en": "Box",
      "es": "Caja"
    },
    "order": 43,
    "is_active": true,
    "metadata": {
      "symbol": "caja",
      "category": "count"
    }
  },
  {
    "code": "PALLET",
    "label": {
      "en": "Pallet",
      "es": "Pale"
    },
    "order": 44,
    "is_active": true,
    "metadata": {
      "symbol": "palet",
      "category": "count"
    }
  },
  {
    "code": "HOUR",
    "label": {
      "en": "Hour",
      "es": "Hora"
    },
    "order": 50,
    "is_active": true,
    "metadata": {
      "symbol": "h",
      "category": "time"
    }
  },
  {
    "code": "DAY",
    "label": {
      "en": "Day",
      "es": "Dia"
    },
    "order": 51,
    "is_active": true,
    "metadata": {
      "symbol": "d",
      "category": "time"
    }
  },
  {
    "code": "MONTH",
    "label": {
      "en": "Month",
      "es": "Mes"
    },
    "order": 52,
    "is_active": true,
    "metadata": {
      "symbol": "mes",
      "category": "time"
    }
  },
  {
    "code": "YEAR",
    "label": {
      "en": "Year",
      "es": "Ano"
    },
    "order": 53,
    "is_active": true,
    "metadata": {
      "symbol": "ano",
      "category": "time"
    }
  },
  {
    "code": "PERCENT",
    "label": {
      "en": "Percentage",
      "es": "Porcentaje"
    },
    "order": 90,
    "is_active": true,
    "metadata": {
      "symbol": "%",
      "category": "other"
    }
  }
]
